import React, { Fragment } from 'react';

import './Fieldset.scss';

import Toggle from 'RLX/Forms/Toggle';
import HtmlBox from 'RLX/Forms/HtmlBox';
import TextBox from 'RLX/Forms/TextBox';
import NumberBox from 'RLX/Forms/NumberBox';
import ImageBox from 'RLX/Forms/ImageBox';
import SelectBox from 'RLX/Forms/SelectBox';
import ButtonSet from 'RLX/Forms/ButtonSet';
import CardList from 'RLX/Forms/CardList';
import ImageList from 'RLX/Forms/ImageList';
import RoleSet from 'RLX/Forms/RoleSet';
import ContactList from 'RLX/Forms/ContactList';
import FilteredCardList from 'RLX/Forms/CardList/FilteredCardList';

class Fieldset extends React.Component {
  constructor (props) {
    super(props);
    this.renderField = this.renderField.bind(this);
    this.renderFieldset = this.renderFieldset.bind(this);
  }

  renderField (field, index) {
    const { type, content } = field;
    if (content) return <React.Fragment key={index} children={content}/>
    switch ((type ? type : '').toLowerCase()) {
      case 'image':
        return <ImageBox key={index} {...field}/>
      case 'select':
        return <SelectBox key={index} {...field}/>
      case 'number':
        return <NumberBox key={index} {...field}/>
      case 'code':
      case 'html':
      case 'textarea':
        return <HtmlBox key={index} {...field}/>
      case 'toggle':
        return <Toggle key={index} {...field}/>
      case 'buttonset':
        return <ButtonSet key={index} {...field}/>
      case 'roleset':
        return <RoleSet key={index} {...field}/>
      case 'cardlist':
        return <CardList key={index} {...field}/>
      case 'filteredcardlist':
        return <FilteredCardList key={index} {...field}/>
      case 'imagelist':
        return <ImageList key={index} {...field}/>
      case 'contactlist':
        return <ContactList key={index} {...field}/>
      case 'text':
        return <TextBox key={index} {...field}/>
      default:
        return (
          <div className="fieldset--unknown" key={index}>
            <h3>Unknown field type: <code>{type || ''}</code></h3>
            <p>You may need to add it to <code>Fieldset.jsx</code>.</p>
            <code className="fieldset--unknown-data">
              <pre>
                {JSON.stringify(field, null, '  ')}
              </pre>
            </code>
          </div>
        );
    };
  }

  renderFieldset (fieldList, index) {
    return (
      <fieldset className="Fieldset" key={index}>
        {fieldList.map(this.renderField)}
      </fieldset>
    );
  }

  render () {
    const { fields } = this.props;
    if (!fields || !fields.length || !Array.isArray(fields)) return null;
    const columnMode = fields.every(field => Array.isArray(field));
    return (
      <div className="Fieldset-Group">
        {(columnMode ? fields : [ fields ]).map(this.renderFieldset)}
      </div>
    );
  }
};

export default Fieldset;



// WEBPACK FOOTER //
// ./client/RLX/Forms/Fieldset/Fieldset.jsx